// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"Banner_inputContainer__3fpPj","input":"Banner_input__W8XIT"};